import React, { useEffect, useRef } from 'react';

const Timeline = () => {
  const widgetContainerRef = useRef();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-timeline.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      feedMode: "all_symbols",
      isTransparent: false,
      displayMode: "regular",
      width: "800",
      height: "500",
      colorTheme: "light",
      locale: "in"
    });
  
    const loadScript = () => {
      widgetContainerRef.current.appendChild(script);
    };
    const scriptTimeout = setTimeout(loadScript, 1000);
    return () => {
      if (widgetContainerRef.current && widgetContainerRef.current.contains(script)) {
        widgetContainerRef.current.removeChild(script);
      }
      clearTimeout(scriptTimeout);
    };
  }, []);

  return (
    <div className="tradingview-widget-container" ref={widgetContainerRef} style={{boxShadow:' 0 0 20px rgba(0, 0, 0, 0.5)',}}>
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
};

export default Timeline;